import { Card } from '@scuf/common';
import React from 'react';
import './DSNotConfiguredLandscape.scss';
import DefaultPageIcon from '../../assets/errorDefaultPage.svg';

interface IDSNotConfiguredLandscape {
  title: string;
  text: string;
}

function DSNotConfiguredLandscape(props: IDSNotConfiguredLandscape) {
  return (
    <Card className="not-configured-container">
      <div className="container">
        <img src={DefaultPageIcon} className="error-pin"></img>
        <div className="heading-1">{props.title}</div>
        <div className="heading-2">{props.text}</div>
      </div>
    </Card>
  );
}

export default DSNotConfiguredLandscape;
